<template>
  <div>
    <GameSettingTitle :input="value" @handleSaveDraft="handleSaveDraft" />
    <GameSettingTab :value="view" :input="value" @handleChangeView="handleChangeView" />
    <div class="z-border-red pa-2 pt-4">
      <div class="text-xs-right">
        <v-btn color="primary" @click="handleExport">
          <v-icon class="mr-2">download</v-icon>Download Form
        </v-btn>

        <importxlsx :loading="importLoading" @onChange="handleImport">
          <template #default="{ loading, onClickUploadButton }">
            <v-btn
              :loading="loading"
              outline
              class="mx-0"
              color="primary"
              @click="onClickUploadButton"
            >
              <v-icon class="mr-2">upload</v-icon> {{ $t('IMPORT') }}
            </v-btn>
          </template>
        </importxlsx>
      </div>

      <v-data-table
        :headers="headers"
        :pagination.sync="pagination"
        :items="privileges"
        class="mt-2 elevation-1"
        hide-actions
        :loading="loading"
      >
        <template #items="props">
          <td>{{ props.index + 1 }}</td>
          <td class="py-2">
            <v-text-field
              v-model="props.item.name"
              v-validate="`required`"
              outline
              class="default-input"
              placeholder="Privilege"
              single-line
              :name="`privilege_${props.index}`"
              :data-vv-as="`Name ${props.index + 1}`"
              :has-details="!errors.has(`privilege_${props.index}`)"
              :error="errors.has(`privilege_${props.index}`) ? true : false"
              :error-messages="
                errors.has(`privilege_${props.index}`)
                  ? errors.first(`privilege_${props.index}`)
                  : ''
              "
            />
          </td>
          <td class="py-2">
            <v-text-field
              v-model="props.item.drop_rate"
              v-validate="`required`"
              outline
              class="default-input"
              placeholder="Drop rate %"
              single-line
              :name="`drop_rate_${props.index}`"
              :data-vv-as="`Drop rate ${props.index + 1}`"
              :has-details="!errors.has(`drop_rate_${props.index}`)"
              :error="errors.has(`drop_rate_${props.index}`) ? true : false"
              :error-messages="
                errors.has(`drop_rate_${props.index}`)
                  ? errors.first(`drop_rate_${props.index}`)
                  : ''
              "
              @blur="$set(props.item, 'drop_rate', decimalOnly($event))"
            />
          </td>
          <td class="py-2">
            <uploadfile
              v-model="props.item.logo"
              v-validate="'required'"
              :name="`image_${props.index}`"
              :height="50"
              data-vv-as="Logo"
            >
              <v-btn flat fab small><v-icon small>camera_alt</v-icon></v-btn>
            </uploadfile>
            <div class="caption">ขนาดรูป 100px x 100px</div>
            <div
              v-if="errors.has(`image_${props.index}`)"
              class="text-error text-xs-center error--text"
            >
              {{ errors.first(`image_${props.index}`) }}
            </div>
          </td>
          <td>
            <v-btn outline icon @click="handleDelete(props)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>

      <div v-if="privileges.length < 8" class="text-xs-center my-2">
        <v-btn :loading="loading" @click="handleAddPrivilege">
          <v-icon class="mr-2">add</v-icon>
          Add Privilege
        </v-btn>
      </div>

      <v-layout wrap class="my-3">
        <v-flex xs6 sm3 class="pa-2 font-weight-bold text-center mb-2">โอกาสที่จะได้</v-flex>
        <v-flex xs6 sm3 class="mb-2">
          <div class="primary pa-2 white--text">{{ allDropRate }}%</div>
        </v-flex>
        <v-flex xs6 sm3 class="pa-2 font-weight-bold text-center mb-2">โอกาสที่ไม่ได้</v-flex>
        <v-flex xs6 sm3 class="mb-2">
          <div class="primary pa-2 white--text">{{ 100 - allDropRate }}%</div>
        </v-flex>
      </v-layout>

      <div class="text-xs-center">
        <v-btn outline color="grey" @click="handleBack">
          {{ $t('Back') }}
        </v-btn>
        <v-btn color="primary" @click="handleSubmit()">
          {{ $t('Next') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx'
import importxlsx from '@/components/elements/importxlsx.vue'
import uploadfile from '@/components/elements/uploadfile'
import generaliApi from '@/api/generali'
import { handleResponse, handleApiError } from '@/api/util'
import GameSettingTab from './GameSettingTab'
import GameSettingTitle from './GameSettingTitle'
export default {
  components: {
    uploadfile,
    importxlsx,
    GameSettingTab,
    GameSettingTitle
  },
  inject: ['$validator'],
  props: ['value', 'view'],
  data() {
    return {
      headers: [
        { text: 'No', sortable: false },
        { value: 'name', text: 'Privilege', sortable: false },
        { value: 'drop_rate', text: 'Drop Rate %', sortable: false },
        { value: 'logo', text: 'Logo', sortable: false }
      ],
      privileges: [],
      pagination: { sortBy: 'value', descending: true, rowsPerPage: 15 },
      importLoading: false,
      loading: false
    }
  },
  computed: {
    allDropRate() {
      return this.privileges.reduce((prev, curr) => {
        if (curr) {
          try {
            if (this.isNumber(curr.drop_rate)) {
              const drop_rate = parseFloat(curr.drop_rate)
              prev += !isNaN(drop_rate) ? parseFloat(drop_rate) : 0
            }
          } catch (error) {
            console.error(error)
          }
        }
        return prev
      }, 0)
    }
  },
  async mounted() {
    this.loading = true
    await this.handleGetPrivilege()
    this.loading = false
  },
  methods: {
    async handleSaveDraft() {
      const vm = this
      vm.$emit('handleSaveDraft')
      vm.handleSubmit(() => {
        vm.$emit('handleShowSnackbar', true)
      })
    },
    async handleChangeView(view) {
      const vm = this
      vm.handleSubmit(() => {
        vm.$emit('handleSubmit', { view: view, data: vm.input })
      })
    },
    handleAddPrivilege() {
      this.privileges.push({ name: '', drop_rate: '', logo: '' })
    },
    async handleDelete(props) {
      let hasError = false
      if (props.item.id) {
        try {
          const response = await generaliApi.deletePrivilege({
            data: {},
            config: {},
            privilegeId: props.item.id
          })
          await handleResponse(response)
        } catch (error) {
          handleApiError(error)
          hasError = true
        }
      }
      if (!hasError) {
        this.privileges.splice(props.index, 1)
      }
    },
    async handleGetPrivilege() {
      try {
        const response = await generaliApi.getPrivileges({
          config: {
            params: {
              campaign_id: this.value.id
            }
          }
        })
        await handleResponse(response)
        if (response.data.data.length) {
          this.privileges = response.data.data
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    handleBack() {
      this.$emit('handleSubmit', { step: 2, data: this.input })
    },
    async handleSubmit(callback) {
      const result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      if (this.allDropRate >= 0 && this.allDropRate <= 100) {
        const privilegePromise = this.privileges.map((privilege) => {
          return this.handleSavePrivilege(privilege)
        })
        await Promise.all(privilegePromise)
        if (callback) {
          callback()
        } else {
          this.$emit('handleSubmit', { step: 4, data: this.input })
        }
      } else {
        await this.$swal.fire({
          title: 'Drop rate ไม่ถูกต้อง',
          text: 'Drop rate ต้องมากกว่าเท่ากับ 0 หรือน้อยกว่าเท่ากับ 100'
        })
      }
    },
    async handleSavePrivilege(privilege) {
      const data = {
        campaign_id: this.value.id,
        ...privilege
      }
      if (privilege.id) {
        return generaliApi.patchPrivilege({ privilegeId: privilege.id, data, config: {} })
      } else {
        return generaliApi.postPrivilege({ data, config: {} })
      }
    },
    handleExport() {
      let json = []
      if (this.privileges.length) {
        json = this.privileges.map((privilege) => ({
          privilege: privilege.name,
          drop_rate: privilege.drop_rate
        }))
      } else {
        json = [
          {
            privilege: '',
            drop_rate: ''
          }
        ]
      }

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'privilege-table.xlsx')
    },
    transformHeaderField(data) {
      try {
        return data.map((item) => {
          const tempItem = {
            ...item
          }

          Object.keys(item).forEach((element) => {
            switch (element) {
              case 'privilege':
                tempItem.name = item[element]
                break
              default:
              // code block
            }
          })
          return tempItem
        })
      } catch (error) {
        console.error(error)
        return []
      }
    },
    async handleImport(item) {
      this.importloading = true
      let privileges = [...this.transformHeaderField(item[0])]
      privileges.length = 8

      const all_drop_rate = privileges.reduce((prev, curr) => {
        if (curr && curr.name && curr.drop_rate) {
          try {
            if (this.isNumber(curr.drop_rate)) {
              const drop_rate = parseFloat(curr.drop_rate)
              prev += !isNaN(drop_rate) ? parseFloat(drop_rate) : 0
            }
          } catch (error) {
            console.error(error)
          }
        }
        return prev
      }, 0)
      if (all_drop_rate >= 0 && all_drop_rate <= 100) {
        this.privileges = privileges
          .map((privilege) => {
            const existPrivilege = this.privileges.find(
              (pri) => privilege && pri.name == privilege.name
            )

            if (privilege && privilege.name && privilege.drop_rate) {
              return existPrivilege ? { ...existPrivilege, ...(privilege || {}) } : privilege
            } else {
              return null
            }
          })
          .filter(Boolean)
        // await this.$swal.fire({
        //   text: 'สำเร็จ',
        //   type: 'success'
        // })
      } else {
        await this.$swal.fire({
          text: 'Drop rate ไม่ถูกต้อง'
        })
      }
      // var data = {
      //   page_id: this.selectedBot.pageid,
      //   campaign_id: this.value.id,
      //   codes: item[0]
      // }
    },
    async handleCreatePrivilege() {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/Privilege.vue